module.exports = __webpack_public_path__ + "assets/da46ca3d6b2b92b2b32d726f983812f5.mp3";